// Lightweight WebAudio chime presets — no audio assets needed.
// Each preset is a list of [frequencyHz, startOffsetSec] notes.
export const SOUND_PRESETS = {
  rise: { label: "Rising", notes: [[660, 0], [880, 0.1], [1175, 0.2]] },
  drop: { label: "Falling", notes: [[880, 0], [660, 0.1], [440, 0.2]] },
  chime: { label: "Chime", notes: [[880, 0], [1320, 0.12]] },
  ding: { label: "Ding", notes: [[1568, 0]] },
  alarm: { label: "Alarm", notes: [[988, 0], [988, 0.18], [988, 0.36]] },
  none: { label: "Silent", notes: [] },
};

export const playSound = (presetId) => {
  const preset = SOUND_PRESETS[presetId] || SOUND_PRESETS.chime;
  if (!preset.notes.length) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const now = ctx.currentTime;
    preset.notes.forEach(([f, t]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.0001, now + t);
      gain.gain.exponentialRampToValueAtTime(0.25, now + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.22);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + t);
      osc.stop(now + t + 0.24);
    });
    setTimeout(() => ctx.close(), 900);
  } catch (e) {
    console.debug("playSound skipped:", e);
  }
};
